import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getEmploymentCertificate = personId => {
  return dispatch => {
    dispatch({ type: "GET_EMPLOYMENT_CERTIFICATE_LOADING" });
    api
      .employmentCertificateGet(personId)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchEmploymentCertificateErrorAlertTitle",
          "Virhe työtodistusten lukemisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_EMPLOYMENT_CERTIFICATE_SUCCEEDED",
  payload: { employmentCertificate: data },
});

const operationFail = () => ({
  type: "GET_EMPLOYMENT_CERTIFICATE_FAIL",
});
